// extracted by mini-css-extract-plugin
module.exports = {"contact":"ComponentTest_contact__Gm09v","imageWrapper":"ComponentTest_imageWrapper__i9vmP","title":"ComponentTest_title__wcf_b"};